function Gallery(){
    return(
        <div className="gallery">
            <h1>TEST</h1>
        </div>
    )

}

export default Gallery